module.exports = __webpack_public_path__ + "img/live-stream-white.c19a158b.svg";